export interface Video {
  id: string;
  title: string;
  duration: string;
  videoUrl: string;
  thumbnail?: string;
}

export const ONBOARDING_VIDEOS: Video[] = [
  {
    id: '1',
    title: 'Platform Demo',
    duration: '9:18',
    videoUrl: 'https://storage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4', // Placeholder - replace with actual Attio video
  },
  {
    id: '2',
    title: 'Getting Started',
    duration: '5:42',
    videoUrl: 'https://storage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4', // Placeholder
  },
  {
    id: '3',
    title: 'Data Enrichment',
    duration: '7:30',
    videoUrl: 'https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4', // Placeholder
  },
  {
    id: '4',
    title: 'Managing Workspaces',
    duration: '4:15',
    videoUrl: 'https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4', // Placeholder
  },
];
